import { LaskutettavatPalvelut } from '@lemon/core-firebase/model/lasku'
import { TuotteetService } from '@lemon/core-firebase/service/tuotteet-service'
import { LocalDate } from '@lemon/core/model/common'
import { DateService } from '@lemon/core/service/date.service'
import { AsiakkaanMuuJatkuvaVeloitus, AsiakkaanSopimuskaudenTauko } from '../model/asiakas'

export class VeloituksetService {
  constructor(
    private _dateService: DateService,
    private _tuotteetService: TuotteetService,
  ) {}

  public annaAktiivisetMuutVeloitukset(veloitukset: AsiakkaanMuuJatkuvaVeloitus[]): AsiakkaanMuuJatkuvaVeloitus[] {
    if (!veloitukset || veloitukset.length < 1) {
      return []
    }
    return veloitukset.filter(v => !v.poistettu)
  }

  public pitaakoLahettaaMuutJatkuvatVeloitukset(sopimusOnVoimassaTassaKuussa: boolean, tauko: AsiakkaanSopimuskaudenTauko, veloitukset: AsiakkaanMuuJatkuvaVeloitus[]): boolean {
    if (sopimusOnVoimassaTassaKuussa && !tauko) {
      return true
    }
    if (sopimusOnVoimassaTassaKuussa && tauko && veloitukset && veloitukset.length > 0) {
      return veloitukset.some(v => this.onkoTauollaSallittuTuote(v.tuote, tauko))
    }
    return false
  }

  public onkoTauollaSallittuTuote(tuoteAvain: string, tauko: AsiakkaanSopimuskaudenTauko): boolean {
    if (tauko?.tyyppi === 'poytalaatikko') {
      if (tuoteAvain === LaskutettavatPalvelut.AINEISTON_SAILYTYSMAKSU) {
        return true
      }
    }
    return false
  }

  public annaMuutJatkuvatVeloituksetKuukaudelle(veloitukset: AsiakkaanMuuJatkuvaVeloitus[], kuukausi: LocalDate): AsiakkaanMuuJatkuvaVeloitus[] {
    if (!veloitukset || veloitukset.length < 1) {
      return []
    }
    return veloitukset.filter(veloitus => this.onkoLaskutettavaKuukautena(veloitus, kuukausi))
  }

  public onkoLaskutettavaKuukautena(veloitus: AsiakkaanMuuJatkuvaVeloitus, kuukausi: LocalDate): boolean {
    return this.onkoMuuJatkuvaVeloitusVoimassaTassaKuussa(veloitus, kuukausi) && this.onkoMuuJatkuvaVeloitusLaskutusKuukausi(veloitus, kuukausi)
  }

  private onkoMuuJatkuvaVeloitusVoimassaTassaKuussa(veloitus: AsiakkaanMuuJatkuvaVeloitus, kuukaudenAlku: LocalDate): boolean {
    // Tarkista, että veloitus on alkanut viimeistään kuukauden alussa
    if (this._dateService.compareLocalDates(veloitus.voimassaAlkaen, '>', kuukaudenAlku)) {
      return false
    }

    // Tarkista, että veloitus ei ole päättynyt ennen kuukauden alkua
    if (veloitus.paattyy && this._dateService.compareLocalDates(veloitus.paattyy, '<', kuukaudenAlku)) {
      return false
    }

    return true
  }

  private onkoMuuJatkuvaVeloitusLaskutusKuukausi(veloitus: AsiakkaanMuuJatkuvaVeloitus, laskutusKuukausi: LocalDate): boolean {
    const alkamisKuukausi: LocalDate = { year: veloitus.voimassaAlkaen.year, month: veloitus.voimassaAlkaen.month, day: 1 }

    const kuukausiaValissa = this._dateService.kuukausiaValissa(this._dateService.localDateToDate(alkamisKuukausi), this._dateService.localDateToDate(laskutusKuukausi))

    if (veloitus.frekvenssi === '1kk') {
      return true
    } else if (veloitus.frekvenssi === '3kk') {
      return kuukausiaValissa % 3 === 0
    } else if (veloitus.frekvenssi === 'vuosi') {
      return kuukausiaValissa % 12 === 0
    } else {
      return false
    }
  }
}
